import { getTheme, mergeStyles } from '@fluentui/react';

const theme = getTheme();

// ============================== SelectedWidgets styles ==============================
export const selectedWidgetsStyles = mergeStyles({
    width: '75%',
    height: '250px',
    position: 'absolute',
    bottom: '1%',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '15px',
    overflow: 'hidden'
});

// export const navigationButtonStyles = mergeStyles({
//     position: 'absolute',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     backgroundColor: 'rgba(255, 255, 255, 0.7)',
//     boxShadow: '0 2px 4px rgba(0,0,0,0.4)',
//     borderRadius: '50%',
//     zIndex: 1,
//     '&:hover': {
//         backgroundColor: '#f0f0f0'
//     }
// });

export const navigationButtonStyles = mergeStyles({
    position: 'absolute',
    top: '35%',
    transform: 'translateY(-50%)',
    backgroundColor: '#fff',
    color: '#000',
    border: '2px solid rgba(0, 0, 0, 0.3)',
    borderRadius: '50%',
    boxShadow: '0 2px 6px rgba(0,0,0,0.5)',
    zIndex: 1,
    transition: 'background-color 0.2s ease',
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        color: '#FFFFFF',
        border: '2px solid rgba(0, 0, 0, 0.3)'
    }
});

export const widgetsContainerStyles = mergeStyles({
    display: 'flex',
    flexDirection: 'row',
    gap: '15px',
    transition: 'transform 0.3s ease'
});

// ============================== WidgetCard styles ==============================
export const widgetCardStyles = mergeStyles({
    width: '250px',
    height: '240px',
    position: 'relative',
    '&:hover .widget-actions': {
        opacity: 1,
        visibility: 'visible'
    }
});

export const widgetImageStyles = mergeStyles({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 10
});

export const widgetImageOriginalStyles = mergeStyles({
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: 10,
    backgroundColor: '#f8f8f8'
});

export const widgetActionsStyles = mergeStyles({
    position: 'absolute',
    top: '0px',
    right: '0px',
    display: 'flex',
    gap: '8px',
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 0.2s ease, visibility 0.2s ease',
    backgroundColor: 'rgba(255,255,255,0.7)',
    borderRadius: '4px',
    padding: '2px',
    zIndex: 10
});

export const headerStyles = mergeStyles({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    padding: 8,
    backgroundColor: 'rgba(255,255,255,0.9)',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10
});

export const footerStyles = mergeStyles({
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 8,
    backgroundColor: 'rgba(255,255,255,0.9)',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10
});

export const actionButtonBase = {
    width: 32,
    height: 32
};

export const editButtonStyles = {
    root: {
        ...actionButtonBase,
        color: theme.palette.neutralPrimary
    },
    rootHovered: {
        backgroundColor: '#fff'
    }
};

export const deleteButtonStyles = {
    root: {
        ...actionButtonBase,
        color: theme.palette.red
    },
    rootHovered: {
        backgroundColor: '#fff',
        color: theme.palette.red
    }
};

export const dragHandleStyles = {
    root: {
        ...actionButtonBase,
        color: theme.palette.neutralPrimary,
        cursor: 'grab'
    },
    rootHovered: {
        backgroundColor: '#fff'
    }
};

// ============================== EnlargeWidgets styles ==============================
export const closeButtonStyles = {
    root: {
        width: 30,
        height: 30,
        color: theme.palette.themePrimary
    }
};

export const imageStyles: React.CSSProperties = {
    maxWidth: '100%',
    maxHeight: '70vh',
    objectFit: 'contain',
    borderRadius: 8
};

export const linkStyles: React.CSSProperties = {
    color: theme.palette.themePrimary,
    textDecoration: 'none'
};

export const infoIconContainerStyles = (iconBottom: number): React.CSSProperties => ({
    position: 'absolute',
    bottom: iconBottom,
    right: 8,
    zIndex: 10
});

export const infoIconButtonStyles = {
    root: {
        width: '24px',
        height: '24px',
        backgroundColor: 'rgba(255,255,255,0.9)',
        borderRadius: '50%',
        border: '2px solid rgba(0,0,0,0.3)',
        color: '#000',
        boxShadow: '0 0 10px 0 rgba(0,0,0,0.5)'
    },
    rootHovered: {
        backgroundColor: 'rgba(255,255,255,1)',
        color: '#0078d4'
    }
};
